import LayoutContainer from 'components/layout/LayoutContainer';
import React, { useEffect, useCallback, useState, useContext } from 'react';
import Card from 'components/inputs/Card';
import * as _ from 'lodash';
import { DOWNLOAD_CUSTOMER_BOOKING, FETCH_CUSTOMER_BOOKING, RESCHEDULE_CUSTOMER_BOOKING, CANCEL_CUSTOMER_BOOKING } from 'actions/customer';
import { DOWNLOAD_SINGLE_INVOICE } from 'actions/invoice';
import { START_REMOTE } from 'actions/chargerBooking';
import { REMOTE_STOP_TRANSACTION } from 'actions/chargerOcpp';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import ReactPagination from 'components/general/ReactPagination';
import { BiSort } from 'react-icons/bi';
import { FaChargingStation } from 'react-icons/fa';
import { roundOfDigit } from 'components/common/utils';
import moment from 'moment';
import DropDown from 'components/inputs/DropDown';
import { Col, Row, Spinner, Modal } from 'react-bootstrap';
import { BsFilter } from 'react-icons/bs';
import { AiFillCaretDown } from 'react-icons/ai';
import DateTimePicker from 'components/inputs/DateTimePicker';
import { SiGooglesheets } from 'react-icons/si';
import Button from 'components/inputs/Button';
import fileDownload from 'js-file-download';
// import { useHistory } from 'react-router-dom';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { NavContext } from 'components/privateRoute/PrivateRoute';
import { useTranslation } from 'react-i18next';
import { GrMoreVertical } from 'react-icons/gr';
import BookingModal from './BookingModal';
import { toast } from 'react-toastify';
import { UPDATE_STATUS_CODE } from 'components/common/constant';
import { Formik, Form } from 'formik';
import { MdClose } from 'react-icons/md';
import * as Yup from 'yup';
import { useLocation } from 'react-router-dom';
import TextInput from 'components/inputs/Input';

const CustomerBooking = () => {
  const dispatch = useDispatch();
  // const history = useHistory();
  const { navigateTo } = useContext(NavContext);
  const { t } = useTranslation();
  const { customerId } = useParams();
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  const [startDate, setStartDate] = useState(moment().startOf('week').utc());
  const [endDate, setEndDate] = useState(moment().endOf('day').utc());
  const [fieldValue, setFieldValue] = useState('all');
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [showTimingModal, setShowTimingModal] = useState(false);
  const [showStopTransaction, setShowStopTransaction] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [id, setId] = useState('');
  const [downloading, setDownloading] = useState({});

  const customerBookingList = useSelector((state) => state.customerBooking.customerBooking);
  const page = useSelector((state) => state.customerBooking.page);
  const totalData = useSelector((state) => state.customerBooking.total);
  const limit = useSelector((state) => state.customerBooking.limit);
  const totalPages = useSelector((state) => state.customerBooking.totalPages);
  const isLoading = useSelector((state) => state.downloadingLoader.isLoading);

  const location = useLocation();
  const isAdminRoute = location.pathname.includes('/customerProfileAdmin');

  // Helper function to conditionally add status to filter data
  const addStatusIfNeeded = useCallback((data) => {
    if (fieldValue !== 'all' && fieldValue) {
      data.status = fieldValue;
    }
    return data;
  }, [fieldValue]);

  const getCustomerBooking = useCallback(
    (data) => {
      const bookingData = {
        ...data,
        id: customerId,
        ...(isAdminRoute ? { isAdmin: true } : null),
      };
      dispatch({ type: FETCH_CUSTOMER_BOOKING.REQUEST, payload: bookingData });
    },
    [customerId]
  );

  const cancelCustomerBooking = useCallback(
    (data) => {
      const bookingData = {
        ...data,
        userId: customerId,
      };
      dispatch({
        type: CANCEL_CUSTOMER_BOOKING.REQUEST,
        payload: bookingData,
        cb: (res) => {
          if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
            toast.success('Booking Cancelled successfully');
            setTimeout(() => {
              window.location.reload();
            }, 1000);
            navigateTo(isAdminRoute ? `/customerProfileAdmin/${customerId}` : `/customerProfile/${customerId}`);
          }
        },
      });
    },
    [customerId]
  );

  const rescheduleCustomerBooking = useCallback(
    (data) => {
      const bookingData = {
        ...data,
        userId: customerId,
      };
      dispatch({ type: RESCHEDULE_CUSTOMER_BOOKING.REQUEST, payload: bookingData });
    },
    [customerId]
  );

  const downloadInvoice = useCallback(
    (bookingId) => {
      const chargerBookingId = bookingId || id;
      setDownloading((prev) => ({
        ...prev,
        [chargerBookingId]: true,
      }));
      dispatch({
        type: DOWNLOAD_SINGLE_INVOICE.REQUEST,
        payload: chargerBookingId,
        cb: (res) => {
          if (res) {
            if (_.get(res, 'status') === 200) {
              fileDownload(res.data, `${'Invoice'}.pdf`);
            }
          }
          setDownloading((prev) => ({
            ...prev,
            [chargerBookingId]: false,
          }));
        },
      });
    },
    [id, dispatch]
  );

  const startCharging = useCallback(
    (bookingItem) => {
      const remote = {
        id: _.get(bookingItem, 'charger.id', ''),
        idTag: _.get(bookingItem, 'idTag', '').toString(),
        connectorId: _.get(bookingItem, 'connectorId', ''),
      };
      dispatch({ 
        type: START_REMOTE.REQUEST, 
        payload: { data: remote },
      });
      setTimeout(() => {
        const filterDateData = {
          from: moment(startDate).utc().toDate(),
          to: moment(endDate).utc().toDate(),
        };
        const refreshData = addStatusIfNeeded({
          page,
          limit,
          ...filterDateData,
        });
        getCustomerBooking(refreshData);
      }, 1000);
    },
    [dispatch, startDate, endDate, fieldValue, page, limit, getCustomerBooking]
  );

  const dateFilter = useCallback(() => {
    if (sortByItem.item && sortByItem.order) {
      const filterDateData = {
        from: moment(startDate).utc().toDate(),
        to: moment(endDate).utc().toDate(),
      };
      getSortByItem(sortByItem.item, sortByItem.order, '', filterDateData);
    } else {
      const filterDateData = {
        from: moment(startDate).utc().toDate(),
        to: moment(endDate).utc().toDate(),
      };
      getCustomerBooking(filterDateData);
    }
  }, [startDate, endDate, sortByItem]);

  useEffect(() => {
    getCustomerBooking(); // Call getCustomerBooking when the component first loads
    dateFilter(); // Call dateFilter after invoking getCustomerBooking
  }, []);

  const handleSearchClick = () => {
    if (fieldValue && startDate && endDate) {
      const filterDateData = addStatusIfNeeded({
        from: moment(startDate).utc().toDate(),
        to: moment(endDate).utc().toDate(),
      });
      getCustomerBooking(filterDateData);
    } else if (fieldValue) {
      const filterDateType = addStatusIfNeeded({});
      getCustomerBooking(filterDateType);
      dateFilter(); // Call dateFilter after invoking getCustomerBooking
    } else {
      getCustomerBooking();
    }
  };
  const handlePageClick = (page) => {
    if (sortByItem.item && sortByItem.order) {
      const filterDateData = {
        from: moment(startDate).utc().toDate(),
        to: moment(endDate).utc().toDate(),
      };
      getSortByItem(sortByItem.item, sortByItem.order, page, filterDateData);
    } else if (page && fieldValue && startDate && endDate) {
      const allStatus = {
        from: moment(startDate).utc().toDate(),
        to: moment(endDate).utc().toDate(),
        page: page.selected + 1,
      };
      const filterData = addStatusIfNeeded({
        from: moment(startDate).utc().toDate(),
        to: moment(endDate).utc().toDate(),
        page: page.selected + 1,
      });
      fieldValue === 'all' ? getCustomerBooking(allStatus) : endDate && getCustomerBooking(filterData);
    } else if (page && startDate && endDate) {
      const filterData = {
        from: moment(startDate).utc().toDate(),
        to: moment(endDate).utc().toDate(),
        page: page.selected + 1,
      };
      endDate && getCustomerBooking(filterData);
    } else if (page && fieldValue) {
      const allStatus = {
        page: page.selected + 1,
      };
      const filterDateType = addStatusIfNeeded({
        page: page.selected + 1,
      });
      fieldValue === 'all' ? getCustomerBooking(allStatus) : getCustomerBooking(filterDateType);
    } else if (page) {
      const data = {
        page: page.selected + 1,
      };
      getCustomerBooking(data);
    }
  };

  const getSortByItem = (name, order, page, filterDateData) => {
    const sortedOrder = order || 'asc';
    if (page && startDate && endDate && fieldValue) {
      const allStatus = {
        from: moment(startDate).utc().toDate(),
        to: moment(endDate).utc().toDate(),
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      const data = addStatusIfNeeded({
        from: moment(startDate).utc().toDate(),
        to: moment(endDate).utc().toDate(),
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      });
      fieldValue === 'all' ? getCustomerBooking(allStatus) : endDate && getCustomerBooking(data);
    } else if (page && startDate && endDate) {
      const data = {
        from: moment(startDate).utc().toDate(),
        to: moment(endDate).utc().toDate(),
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      endDate && getCustomerBooking(data);
    } else if (page && fieldValue) {
      const allStatus = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      const data = addStatusIfNeeded({
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      });
      fieldValue === 'all' ? getCustomerBooking(allStatus) : getCustomerBooking(data);
    } else if (page) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      getCustomerBooking(data);
    } else if (filterDateData) {
      const data = {
        ...filterDateData,
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      endDate && getCustomerBooking(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      getCustomerBooking(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const filterData = [
    { label: 'all', value: 'all' },
    { label: 'completed', value: 'completed' },
    { label: 'scheduled', value: 'scheduled' },
    { label: 'cancelled', value: 'cancelled' },
    { label: 'in_progress', value: 'in_progress' },
  ];

  const downloadCustomerBooking = useCallback(
    (data = {}) => {
      if (fieldValue && startDate && endDate) {
        const bookingData = {
          id: customerId,
          ...(isAdminRoute ? { isAdmin: true } : {}),
          excel: true,
          from: moment(startDate).utc().toDate(),
          to: moment(endDate).utc().toDate(),
          status: fieldValue,
          ...data,
        };
        const allData = {
          id: customerId,
          ...(isAdminRoute ? { isAdmin: true } : {}),
          excel: true,
          from: moment(startDate).utc().toDate(),
          to: moment(endDate).utc().toDate(),
          ...data,
        };
        const customerBookingData = fieldValue === 'all' ? allData : bookingData;
        dispatch({
          type: DOWNLOAD_CUSTOMER_BOOKING.REQUEST,
          payload: customerBookingData,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                fileDownload(res.data, `${'Customer Booking'}.xlsx`);
              }
            }
          },
        });
      } else if (startDate && endDate) {
        const customerBookingData = {
          id: customerId,
          ...(isAdminRoute ? { isAdmin: true } : {}),
          excel: true,
          from: moment(startDate).utc().toDate(),
          to: moment(endDate).utc().toDate(),
          ...data,
        };
        dispatch({
          type: DOWNLOAD_CUSTOMER_BOOKING.REQUEST,
          payload: customerBookingData,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                fileDownload(res.data, `${'Customer Booking'}.xlsx`);
              }
            }
          },
        });
      } else if (fieldValue) {
        const bookingData = {
          id: customerId,
          ...(isAdminRoute ? { isAdmin: true } : {}),
          excel: true,
          status: fieldValue,
          ...data,
        };
        const allData = {
          id: customerId,
          ...(isAdminRoute ? { isAdmin: true } : {}),
          excel: true,
          ...data,
        };
        const customerBookingData = fieldValue === 'all' ? allData : bookingData;
        dispatch({
          type: DOWNLOAD_CUSTOMER_BOOKING.REQUEST,
          payload: customerBookingData,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                fileDownload(res.data, `${'Customer Booking'}.xlsx`);
              }
            }
          },
        });
      } else {
        const customerBookingData = {
          id: customerId,
          ...(isAdminRoute ? { isAdmin: true } : {}),
          excel: true,
          ...data,
        };
        dispatch({
          type: DOWNLOAD_CUSTOMER_BOOKING.REQUEST,
          payload: customerBookingData,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                fileDownload(res.data, `${'Customer Booking'}.xlsx`);
              }
            }
          },
        });
      }
    },
    [startDate, endDate, fieldValue]
  );

  const RescheduleBookingSchema = Yup.object().shape({
    time: Yup.string().required(t('scheduleBooking.time')),
    date: Yup.string().required(t('scheduleBooking.date')),
  });

  const getCurrentDate = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleCloseModel = () => {
    setShowBookingModal(false);
    setShowTimingModal(false);
    setShowStopTransaction(false);
    setSelectedBooking(null);
  };

  const stopTransaction = useCallback(
    (data) => {
      dispatch({
        type: REMOTE_STOP_TRANSACTION.REQUEST,
        payload: { data },
        cb: (res) => {
          if (res) {
            if (_.get(res, 'status') === 200) {
              toast.success('Remote stop transaction successfully');
              setShowStopTransaction(false);
              setSelectedBooking(null);
              // Refresh the booking list
              const filterDateData = {
                from: moment(startDate).utc().toDate(),
                to: moment(endDate).utc().toDate(),
              };
              const refreshData = addStatusIfNeeded({
                page,
                limit,
                ...filterDateData,
              });
              getCustomerBooking(refreshData);
            } else {
              toast.error(_.get(res, 'data.message', 'Failed to stop transaction'));
            }
          }
        },
      });
    },
    [dispatch, startDate, endDate, fieldValue, page, limit, getCustomerBooking]
  );

  const StopTransactionSchema = Yup.object().shape({
    transactionId: Yup.number().required(t('remoteStopTransaction.transactionId')),
  });
  const handleClick = () => {
    cancelCustomerBooking(id);
    setShowBookingModal(false);
  };
  const downloadFile = () => {
    downloadCustomerBooking();
  };

  return (
    <React.Fragment>
      <LayoutContainer>
        <SkeletonTheme baseColor="#1b2a38" highlightColor="#15212b" enableAnimation="true">
          <Card className="customerBooking-table">
            <Row className="customerBooking-table-heading-row">
              <Col xl={2} lg={6} md={6}>
                <div className="customerBooking-table-heading">{t('header.bookingDetails')}</div>
              </Col>
              <Col xl={2} lg={6} md={6}>
                <DropDown
                  popupClass="main-menu bottom scrollable"
                  trigger={
                    <>
                      <div className="customerBooking-filter-block">
                        <div className="customerBooking-filter-icon">
                          <BsFilter />
                          <span className="customerBooking-filter-label">{_.startCase(fieldValue)}</span>
                        </div>
                        <div className="customerBooking-arrow__icon">
                          <AiFillCaretDown />
                        </div>
                      </div>
                    </>
                  }
                  triggerClass="customerBooking-filter-dropdown"
                >
                  {_.map(filterData, (item, index) => (
                    <ul key={`${index}`}>
                      <li
                        className="item"
                        onClick={() => {
                          setFieldValue(item.value);
                        }}
                      >
                        {_.startCase(item.label)}
                      </li>
                    </ul>
                  ))}
                </DropDown>
              </Col>
              <Col xl={6} lg={9} md={9}>
                <DateTimePicker
                  onChangeOfStartDate={(item) => setStartDate(item)}
                  onChangeOfEndDate={(item) => setEndDate(item)}
                  initialValueOfStartDate={moment().startOf('week')}
                  initialValueOfEndDate={moment().endOf('day')}
                />
              </Col>
              <Col xl={1} lg={2} md={2}>
                <div className="customerBooking-search-box" onClick={handleSearchClick}>
                  <Button className="customerBooking-search-button">{t('button.search')}</Button>
                </div>
              </Col>
              <Col xl={1} lg={1} md={1}>
                {isLoading ? (
                  <div className="loader--block">
                    <Spinner as="span" animation="border" size="sm" role="status" />
                  </div>
                ) : (
                  <div className="customerBooking-excel-icon" onClick={downloadFile}>
                    <SiGooglesheets size={35} color={'#5dad5d'} />
                  </div>
                )}
              </Col>
            </Row>
            <div className="customerBooking-list-table">
              <div className="table-responsive">
                <table className="record-list-table">
                  <thead>
                    <tr>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.srNo')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.stationName')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.ocppId')}</span>
                          <span className="ico" onClick={() => handleSorting('connectorId', sortByItem)}>
                            <BiSort size={15} />
                          </span>
                        </div>
                      </th>
                      {isAdminRoute && (
                        <th>
                          <div className="sorting">
                            <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.tenantName')}</span>
                          </div>
                        </th>
                      )}
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.bookingId')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.bookingType')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.bookingTypeValue')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.bookingMethod')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.idTag')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.scheduledTime')}</span>
                          <span className="ico" onClick={() => handleSorting('schedule_datetime', sortByItem)}>
                            <BiSort size={15} />
                          </span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.status')}</span>
                          <span className="ico" onClick={() => handleSorting('status', sortByItem)}>
                            <BiSort size={15} />
                          </span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.preBookingAmount')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.amountDeductedFromWallet')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.unitUsed')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.pricePerUnit')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.serviceCharge')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.discount')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.taxableValue')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.gst')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.totalAmount')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.extraAmount')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.unusedAmount')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.sessionStartTime')}</span>
                          <span className="ico" onClick={() => handleSorting('booking_start', sortByItem)}>
                            <BiSort size={15} />
                          </span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.sessionStopTime')}</span>
                          <span className="ico" onClick={() => handleSorting('booking_stop', sortByItem)}>
                            <BiSort size={15} />
                          </span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.stopReason')}</span>
                          <span className="ico" onClick={() => handleSorting('stop_reason', sortByItem)}>
                            <BiSort size={15} />
                          </span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.invoiceNumber')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.fleetOwner')}</span>
                        </div>
                      </th>
                      <th>
                        <div className="sorting">
                          <span>{isLoading ? <Skeleton height={15} width={100} /> : t('bookingDetails.action')}</span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {_.isEmpty(customerBookingList) ? (
                      <tr>
                        <td colSpan={isAdminRoute ? 28 : 27} className="border-0">
                          <div className="empty-data-block">{t('bookingDetails.noData')}</div>
                        </td>
                      </tr>
                    ) : (
                      _.map(customerBookingList, (item, index) => {
                        const serial_num = limit * (page - 1) + index;
                        const otp = _.get(item, 'is_rfid_based_booking') === false ? _.get(item, 'idTag') : '-';
                        const rfid = _.get(item, 'is_rfid_based_booking') === true ? _.get(item, 'idTag') : '-';
                        const vid = _.get(item, 'vehicle_id') ? `VID:${_.get(item, 'vehicle_id')}` : null;
                        const idTag = otp !== '-' ? otp : rfid !== '-' ? rfid : vid || '-';
                        
                        const unitConsumed = isNaN(_.get(item, 'meterstop') - _.get(item, 'meterstart'))
                          ? '-'
                          : roundOfDigit((_.get(item, 'meterstop') - _.get(item, 'meterstart')) / 1000, 3);
                        
                        // const paidamount = _.get(item, 'estimated_amount', '');
                        // const estimated_chargecoins = _.get(item, 'chargecoins_estimated', '');
                        // const bookingamount = estimated_chargecoins + paidamount;
                        
                        // Use API keys directly
                        const taxableAmount = _.get(item, 'invoice.subtotal', _.get(item, 'invoice.service_charge', 0) - _.get(item, 'invoice.chargecoins_used', 0));
                        const gst = _.get(item, 'invoice.gst', '');
                        const discountAmount = _.get(item, 'discount_amount', 0);
                        const pricePerUnit = _.get(item, 'invoice.price_per_unit', '-');
                        

                        // Check if there are any actions available for the dropdown
                        const hasActions = 
                          _.get(item, 'status') === 'scheduled' ||
                          (_.get(item, 'status') === 'scheduled' && _.get(item, 'charger?.charging_station?.status') === 'Available') ||
                          _.get(item, 'status') === 'in_progress' ||
                          _.get(item, 'invoice.invoice_number') ||
                          _.get(item, 'invoice_number');

                        return (
                          <tr key={`booking-data-item-${index}`}>
                            <td>{isLoading ? <Skeleton height={15} width={50} /> : serial_num + 1}</td>
                            
                            <td
                              className="station-link"
                              onClick={() =>
                                navigateTo(`/stations/${_.get(item, 'charger.charging_station.id', '')}`, {
                                  backTo: 'chargerStatus',
                                  activeTab: 'reservations',
                                })
                              }
                            >
                              {_.get(item, 'charger.charging_station.name') && (
                                <span className="item-icon">
                                  {isLoading ? <Skeleton circle="true" height={20} width={20} /> : <FaChargingStation size={20} />}
                                </span>
                              )}
                              <span>{isLoading ? <Skeleton height={15} width={100} /> : _.get(item, 'charger.charging_station.name', '-')}</span>
                            </td>

                            <td
                              className="station-link"
                              onClick={() =>
                                navigateTo(`/charger/${_.get(item, 'charger.id', '')}`, {
                                  backTo: 'chargerStatus',
                                })
                              }
                            >
                              {isLoading ? <Skeleton height={15} width={100} /> : `${_.get(item, 'charger.charger_id', '')}(${_.get(item, 'connectorId', '')})`}
                            </td>

                            {isAdminRoute && <td>{isLoading ? <Skeleton height={15} width={100} /> : _.get(item, 'tenant.name', '-')}</td>}
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : _.get(item, '_id', _.get(item, 'id', '-'))}</td>
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : _.get(item, 'booking_type', '-')}</td>
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : _.get(item, 'booking_type_value', '-')}</td>
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : _.get(item, 'booking_method', '-')}</td>
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : idTag}</td>
                            
                            <td>
                              {isLoading ? (
                                <Skeleton height={15} width={100} />
                              ) : _.get(item, 'scheduled_time_ist') ? (
                                _.get(item, 'scheduled_time_ist')
                              ) : (
                                '-'
                              )}
                            </td>
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : _.get(item, 'status', '-')}</td>
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : _.get(item, 'estimated_amount') ? (roundOfDigit(_.get(item, 'estimated_amount', 0), 2)) : '-'}</td>
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : _.get(item, 'wallet_debit_amount') ? (roundOfDigit(_.get(item, 'wallet_debit_amount', 0), 2)) : '-'}</td>
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : unitConsumed}</td>
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : pricePerUnit !== '-' ? roundOfDigit(pricePerUnit, 2) : '-'}</td>
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : roundOfDigit(_.get(item, 'invoice.service_charge', 0), 2)}</td>
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : roundOfDigit(discountAmount, 2)}</td>
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : roundOfDigit(taxableAmount, 2)}</td>
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : roundOfDigit(gst, 2)}</td>
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : _.get(item, 'invoice.total_amount') ? (roundOfDigit(_.get(item, 'invoice.total_amount', 0), 2)) : '-'}</td>

                            <td>{isLoading ? <Skeleton height={15} width={100} /> : _.get(item, 'extra_amount') ? (roundOfDigit(_.get(item, 'extra_amount', 0), 2)) : '-'}</td>
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : _.get(item, 'unused_amount_refund') ? (roundOfDigit(_.get(item, 'unused_amount_refund', 0), 2)) : '-'}</td>
                            
                            <td>
                              {isLoading ? (
                                <Skeleton height={15} width={100} />
                              ) : _.get(item, 'session_start_time_ist') ? (
                                _.get(item, 'session_start_time_ist')
                              ) : (
                                '-'
                              )}
                            </td>
                            
                            <td>
                              {isLoading ? (
                                <Skeleton height={15} width={100} />
                              ) : _.get(item, 'session_stop_time_ist') ? (
                                _.get(item, 'session_stop_time_ist')
                              ) : (
                                '-'
                              )}
                            </td>
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : _.get(item, 'stop_reason', '-')}</td>
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : _.get(item, 'invoice_number', '-')}</td>
                            
                            <td>{isLoading ? <Skeleton height={15} width={100} /> : _.get(item, 'fleet_owner_name', '-')}</td>
                            
                            <td>
                              {isLoading ? (
                                <Skeleton height={15} width={100} />
                              ) : hasActions ? (
                                <DropDown
                                  trigger={
                                    <span className="dropdown-icon">
                                      <GrMoreVertical />
                                    </span>
                                  }
                                  popupClass="bottom-left"
                                  style={{ zIndex: 1000 }}
                                >
                                  <ul>
                                    {_.get(item, 'status') === 'scheduled' && (
                                      <>
                                        <li
                                          className="item"
                                          onClick={() => {
                                            setShowTimingModal(true);
                                            setId(_.get(item, 'id', ''));
                                          }}
                                        >
                                          {t('bookingDetails.rescheduleBooking')}
                                        </li>
                                        <li
                                          className="item"
                                          onClick={() => {
                                            setShowBookingModal(true);
                                            setId({ id: _.get(item, 'id', '') });
                                          }}
                                        >
                                          {t('bookingDetails.cancelBooking')}
                                        </li>
                                      </>
                                    )}
                                    {_.get(item, 'status') === 'scheduled' && 
                                      (_.get(item, 'charger.charging_station.status') === 'Available' || 
                                       _.get(item, 'charger.charger_status') === 'Available' ||
                                       _.get(item, 'charger_status') === 'Available') && (
                                      <li
                                        className="item"
                                        onClick={() => {
                                          startCharging(item);
                                        }}
                                      >
                                        Start Charging
                                      </li>
                                    )}
                                    {_.get(item, 'status') === 'in_progress' && (
                                      <li
                                        className="item"
                                        onClick={() => {
                                          setShowStopTransaction(true);
                                          setSelectedBooking(item);
                                        }}
                                      >
                                        Stop Booking
                                      </li>
                                    )}
                                    {(_.get(item, 'invoice.invoice_number') || _.get(item, 'invoice_number')) && (
                                      <li
                                        className="item"
                                        onClick={() => {
                                          const bookingId = _.get(item, '_id', _.get(item, 'id', ''));
                                          downloadInvoice(bookingId);
                                        }}
                                      >
                                        {downloading[_.get(item, '_id', _.get(item, 'id', ''))] ? (
                                          <>
                                            <Spinner animation="border" size="sm" className="me-2" />
                                            Downloading...
                                          </>
                                        ) : (
                                          'Download Invoice'
                                        )}
                                      </li>
                                    )}
                                  </ul>
                                </DropDown>
                              ) : (
                                '-'
                              )}
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {!_.isEmpty(customerBookingList) && (
              <ReactPagination
                currentPage={page}
                limit={limit}
                total={totalData}
                handlePageClick={(pageVal) => handlePageClick(pageVal)}
                totalPages={totalPages}
                marginPagesDisplayed={1}
              />
            )}
          </Card>
        </SkeletonTheme>

        {showBookingModal && (
          <Modal show={showBookingModal} centered onHide={handleCloseModel}>
            <BookingModal subTitle="Cancel" title="cancel" onClose={handleCloseModel} bookingModel={handleClick} />
          </Modal>
        )}
        {showTimingModal && (
          <Modal show={showTimingModal} size="lg" centered>
            <div className="customer-form-page__main">
              <Card>
                <div className="customer-form-header__block">
                  <div className="customer-header-name">
                    <span>{t('bookingDetails.rescheduleBooking')} </span>
                  </div>
                  <div className="close___btn">
                    <MdClose size={30} color="#BE210B" onClick={handleCloseModel} />
                  </div>
                </div>
                <div className="customer-form-body__block">
                  <div className="customer-form--block">
                    <Formik
                      initialValues={{
                        schedule_datetime: '',
                        date: getCurrentDate(),
                        time: '',
                      }}
                      validationSchema={RescheduleBookingSchema}
                      onSubmit={(values, { setSubmitting }) => {
                        const istDate = new Date(`${values.date}T${values.time}:00.000Z`);
                        const formattedDate = new Date(istDate.getTime() - istDate.getTimezoneOffset() * -60000).toISOString();
                        delete values.date;
                        delete values.time;
                        rescheduleCustomerBooking({
                          ...values,
                          schedule_datetime: formattedDate,
                          id: id,
                        });
                        setSubmitting(false);
                        setShowTimingModal(false);
                      }}
                    >
                      {({ values, handleSubmit, setFieldValue, isSubmitting, touched, errors }) => (
                        <Form onSubmit={handleSubmit}>
                          <Row>
                            <Col>
                              <span className="font-color">{t('placeHolder.scheduleDateTime')}</span>
                              <div>&nbsp;</div>
                              <div className="time_sec">
                                <div className="custome_time">
                                  <input
                                    className="ct_selecter"
                                    name="date"
                                    type="Date"
                                    value={values.date}
                                    min={getCurrentDate()}
                                    onChange={(val) => {
                                      setFieldValue(`date`, val.target.value);
                                    }}
                                  />
                                  <div style={{ color: '#dc4949', fontSize: 10 }}>{errors.date && touched.date ? errors.date : null}</div>
                                </div>
                                <div className="to_sec"></div>
                                <spdivan className="custome_time">
                                  <input
                                    className="ct_selecter"
                                    type="time"
                                    value={values.time}
                                    onChange={(val) => {
                                      const selectedTime = val.target.value;
                                      setFieldValue('time', selectedTime);
                                    }}
                                  />
                                  <div style={{ color: '#dc4949', fontSize: 10 }}>{errors.time && touched.time ? errors.time : null}</div>
                                </spdivan>
                              </div>
                            </Col>
                          </Row>
                          <div className="form-btn__block">
                            <Button className="form_btn cancel____btn" onClick={handleCloseModel}>
                              {t('button.cancel')}
                            </Button>
                            <Button type="submit" disabled={isSubmitting} className="form_btn">
                              {t('button.reschedule')}
                            </Button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </Card>
            </div>
          </Modal>
        )}
        {showStopTransaction && (
          <Modal show={showStopTransaction} size="lg" centered onHide={handleCloseModel}>
            <div className="stop-transaction_main">
              <Card>
                <div className="stop-transaction-header__block">
                  <div className="stop-transaction-name">
                    <span>Stop Booking</span>
                  </div>
                  <div className="close-btn">
                    <MdClose size={30} color="#be210b" onClick={handleCloseModel} />
                  </div>
                </div>
                <div className="stop-transaction_form">
                  <Formik
                    initialValues={{
                      transactionId: _.get(selectedBooking, 'transaction_id', ''),
                    }}
                    validationSchema={StopTransactionSchema}
                    onSubmit={(values, { setSubmitting }) => {
                      const formData = {
                        ...values,
                        id: _.get(selectedBooking, 'charger.id', ''),
                      };
                      stopTransaction(formData);
                      setSubmitting(false);
                    }}
                  >
                    {({ values, errors, touched, handleSubmit, handleChange, isSubmitting }) => (
                      <Form onSubmit={handleSubmit}>
                        <Row>
                          <Col>
                            <TextInput
                              isRequired
                              label={t('remoteStopTransaction.transactionLabel')}
                              placeholder={t('remoteStopTransaction.transactionLabel')}
                              type="number"
                              value={values.transactionId}
                              name="transactionId"
                              onChange={handleChange}
                              error={errors.transactionId && touched.transactionId ? errors.transactionId : null}
                            />
                          </Col>
                        </Row>
                        <div className="stop-transaction_button">
                          <Button className="stop-transaction-btn cancel_btn" onClick={handleCloseModel}>
                            {t('button.cancel')}
                          </Button>
                          <Button type="submit" disabled={isSubmitting} className="stop-transaction-btn create-btn">
                            {t('remoteStopTransaction.button')}
                          </Button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </Card>
            </div>
          </Modal>
        )}
      </LayoutContainer>
    </React.Fragment>
  );
};

export default CustomerBooking;
